import ThirdPartySharing from "@/components/ThirdPartySharing/ThirdPartySharing";
import { availableCapabilities } from "@/components/ThirdPartySharing/useThirdPartySharing";
import { ConnectedAppUserType } from "@WahooFitness/cloud-client-types";
import React from "react";
import { useSearchParams } from "react-router-dom";

const ThirdPartySharingPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  // Any `from` means a deep link opened this page directly, so there is no history entry behind
  // it — the header must offer a close that posts back to the host, not a back chevron that
  // would run navigate(-1) into nothing. Never narrow this to specific callers.
  const from = searchParams.get("from");
  const closeOnBack = !!from;
  const capability = searchParams.get("capability");
  const filterByCapability = availableCapabilities.includes(capability ?? "")
    ? (capability as keyof ConnectedAppUserType)
    : undefined;

  return <ThirdPartySharing closeOnBack={closeOnBack} filterByCapability={filterByCapability} />;
};

export default ThirdPartySharingPage;
